
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.415 30L17.203 10.556v38.888L51.415 30zm4.29 0a4.29 4.29 0 01-2.145 3.732L19.347 53.165a4.29 4.29 0 01-6.435-3.721V10.556a4.29 4.29 0 016.435-3.721L53.56 26.268A4.29 4.29 0 0155.703 30z"}})])
          )
        }
      }
    